<!--
Textarea Component

A ControlValueAccessor field for entering multi-line text values.
Use with Angular Reactive Forms via formControlName or formControl.

Required inputs:
  label: string

Optional inputs:
  placeholder: string (default: '')
  labelPosition: 'top' | 'left' | 'right' | 'hide' (default: 'top')
  resizable: 'horizontal' | 'vertical' | 'both' | 'none' (default: 'none') - Manual resize handle
  height: number (default: 3) - Minimum height in line-height units (lh)
  expandWithContent: boolean (default: true) - Auto-expand height as content grows
  errorMessageId: string (default: auto-generated)

Value Type:
  Emits string | null

Error Messages:
  Use <ui-error-message> with IDs: {errorMessageId}-{validatorName}
  Component automatically links error messages via aria-describedby.

Example:
  <form [formGroup]="myForm">
    <ui-textarea
      formControlName="description"
      label="Description"
      placeholder="Enter description"
      resizable="vertical"
      height="5"
      [expandWithContent]="false"
      errorMessageId="description-error"
    />
    @if (myForm.get('description')?.invalid && myForm.get('description')?.touched) {
      @if (myForm.get('description')?.hasError('required')) {
        <ui-error-message id="description-error-required">
          This field is required.
        </ui-error-message>
      }
      @if (myForm.get('description')?.hasError('maxlength')) {
        <ui-error-message id="description-error-maxlength">
          Maximum 500 characters allowed.
        </ui-error-message>
      }
    }
  </form>

  myForm = new FormGroup({
    description: new FormControl('', [Validators.required, Validators.maxLength(500)])
  });
-->

<label [for]="id" [class]="`${labelPosition()} input-label`">
  <span class="label-text">{{ label() }}</span>
  <span class="input-icon-wrapper">
    <textarea
      #textareaElement
      class="input textarea"
      [class.valid]="isValid()"
      [id]="id"
      [placeholder]="placeholder()"
      [disabled]="disabled()"
      [style.resize]="resizable()"
      [style.field-sizing]="expandWithContent() ? 'content' : 'fixed' "
      [style.min-block-size]="height() + 'lh'"
      [attr.aria-invalid]="isInvalid()"
      [attr.aria-describedby]="errorMessageIds || null"
      (input)="handleOnInput()"
      (blur)="handleOnBlur()"
    >
  </textarea>
    <svg warningIcon aria-hidden="true"></svg>
  </span>
</label>
